import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';

export const AuthGuard: CanActivateFn = async (_route, state) => {
  const userService = inject(UserService);
  if (userService.user()) {
    return true;
  }

  const user = await userService.loadCurrentUser();
  if (user) {
    return true;
  }

  userService.redirectToLogin(state.url);
  return false;
};
